import { ItemGroupI, ItemI, NewNomenkl } from "../../shared";
import { API } from "../../controllers";
import { Color } from "../types/store";
import { isNewSite } from "../../utils";

export const colorMapRuToEn: Record<
    "оцинковка" | "Белый" | "Красный" | "Серый" | "Чёрный" | "Оранж" | "Жёлтый" | "Синий",
    Color
> = {
    оцинковка: "white",
    Белый: "totalWhite",
    Красный: "red",
    Серый: "silver",
    Чёрный: "black",
    Оранж: "orange",
    Жёлтый: "yellow",
    Синий: "blue",
};

const coloredElementsNames = ["соединитель", "штанга", "ребро", "кронштейн", "усилитель"];
const coloredPartElementsNames = ["шкаф"];

/**
 * Обогащает товары информацией о номенклатуре (nameNomenkl, nameNomenklAlt, priceNomenkl, priceAltNomenkl)
 * @param itemsGroup - массив групп товаров
 * @returns обогащенный массив групп товаров
 */
export const enrichItemsWithNomenclature = async (itemsGroup: ItemGroupI[]): Promise<ItemGroupI[]> => {
    // Собираем все уникальные BITRIX_OFFER_ID и BITRIX_OFFER_ID_ALT из всех товаров
    const allOfferIds = new Set<string>();
    const isNew = isNewSite();

    itemsGroup.forEach((group) => {
        group.ELEMENTS?.forEach((item) => {
            if (isNew) {
                if (item.BITRIX_OFFERS_IDS) {
                    item.BITRIX_OFFERS_IDS.forEach((id) => {
                        if (id) {
                            allOfferIds.add(id.toString());
                        }
                    });
                }
            }
            if (item.BITRIX_OFFER_ID) {
                allOfferIds.add(item.BITRIX_OFFER_ID.toString());
            }
            if (item.BITRIX_OFFER_ID_ALT) {
                allOfferIds.add(item.BITRIX_OFFER_ID_ALT.toString());
            }
        });
    });

    if (allOfferIds.size === 0) {
        return itemsGroup;
    }

    try {
        // Получаем информацию о номенклатуре с сервера
        const { data: nomenclatureData } = await API.Configurator.getNomenclatureNamesByOfferIds(
            Array.from(allOfferIds)
        );

        // Обогащаем товары полученной информацией
        const enrichedItemsGroup = itemsGroup.map((group) => ({
            ...group,
            ELEMENTS: group.ELEMENTS?.map((item: ItemI) => {
                const newNomenkl = isNew
                    ? (item.BITRIX_OFFERS_IDS || [])
                          .map((id) => {
                              const name = nomenclatureData[id]?.NAME || "";
                              const price = nomenclatureData[id]?.PRICE || 0;
                              const color = coloredElementsNames.some((el) => name.toLowerCase().includes(el))
                                  ? nomenclatureData[id]?.COLORS?.TSVET
                                  : null;

                              const partedColor =
                                  // @ts-ignore
                                  colorMapRuToEn[nomenclatureData[id]?.COLORS?.TSVET_TSENTRALNOY_CHASTI] === "white" &&
                                  coloredPartElementsNames.some((el) => name.toLowerCase().includes(el))
                                      ? // @ts-ignore
                                        nomenclatureData[id]?.COLORS?.TSVET_BOKOVIN
                                      : null;

                              return id && nomenclatureData[id]
                                  ? {
                                        bitrixId: id,
                                        nameNomenkl: name,
                                        priceNomenkl: price,
                                        color:
                                            // @ts-ignore
                                            colorMapRuToEn[color || partedColor] ||
                                            // @ts-ignore
                                            (Object.entries(nomenclatureData[id]?.COLORS)?.find(
                                                // @ts-ignore
                                                ([key, value]) => colorMapRuToEn[value] === "white"
                                            )
                                                ? "white"
                                                : null),
                                    }
                                  : undefined;
                          })
                          .filter((nomenkl) => nomenkl && nomenkl?.color)
                    : [];

                return {
                    ...item,
                    nameNomenkl: item.BITRIX_OFFER_ID ? nomenclatureData[item.BITRIX_OFFER_ID]?.NAME : undefined,
                    nameNomenklAlt: item.BITRIX_OFFER_ID_ALT
                        ? nomenclatureData[item.BITRIX_OFFER_ID_ALT]?.NAME
                        : undefined,
                    priceNomenkl: item.BITRIX_OFFER_ID ? nomenclatureData[item.BITRIX_OFFER_ID]?.PRICE : undefined,
                    newNomenkl: newNomenkl as NewNomenkl[],
                    priceAltNomenkl: item.BITRIX_OFFER_ID_ALT
                        ? nomenclatureData[item.BITRIX_OFFER_ID_ALT]?.PRICE
                        : undefined,
                    category: item.BITRIX_OFFER_ID_ALT
                        ? nomenclatureData[item.BITRIX_OFFER_ID_ALT]?.CATEGORY
                        : undefined,
                    mounting: item.BITRIX_OFFER_ID_ALT
                        ? nomenclatureData[item.BITRIX_OFFER_ID_ALT]?.MOUNTING
                        : undefined,
                    shelfType: item.BITRIX_OFFER_ID_ALT
                        ? nomenclatureData[item.BITRIX_OFFER_ID_ALT]?.SHELF_TYPE
                        : undefined,
                    rackType: item.BITRIX_OFFER_ID_ALT
                        ? nomenclatureData[item.BITRIX_OFFER_ID_ALT]?.RACK_TYPE
                        : undefined,
                };
            }),
        }));

        return enrichedItemsGroup;
    } catch (error) {
        console.error("Ошибка при получении информации о номенклатуре:", error);
        return itemsGroup; // Возвращаем исходные данные в случае ошибки
    }
};
